/**
 * @generated SignedSource<<0fcbf2c3a17590e69119bcd49f887c61>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "effectiveFrom"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "effectiveTo"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "facilityLocationId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "seq"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "taxonomyId"
},
v5 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "effectiveFrom",
        "variableName": "effectiveFrom"
      },
      {
        "kind": "Variable",
        "name": "effectiveTo",
        "variableName": "effectiveTo"
      },
      {
        "kind": "Variable",
        "name": "facilityLocationId",
        "variableName": "facilityLocationId"
      },
      {
        "kind": "Variable",
        "name": "seq",
        "variableName": "seq"
      },
      {
        "kind": "Variable",
        "name": "taxonomyId",
        "variableName": "taxonomyId"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "NewFacilityLocationTaxonomyModalMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FacilityLocationMutationGroup",
        "kind": "LinkedField",
        "name": "facilityLocation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "FacilityLocationTaxonomyModifyPayload",
            "kind": "LinkedField",
            "name": "createTaxonomy",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FacilityLocationTaxonomy",
                "kind": "LinkedField",
                "name": "facilityLocationTaxonomy",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FacilityLocation",
                    "kind": "LinkedField",
                    "name": "facilityLocation",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FacilityLocationTaxonomy",
                        "kind": "LinkedField",
                        "name": "taxonomies",
                        "plural": true,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "FacilityLocationTaxonomies_Taxonomy"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "NewFacilityLocationTaxonomyModalMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FacilityLocationMutationGroup",
        "kind": "LinkedField",
        "name": "facilityLocation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "FacilityLocationTaxonomyModifyPayload",
            "kind": "LinkedField",
            "name": "createTaxonomy",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FacilityLocationTaxonomy",
                "kind": "LinkedField",
                "name": "facilityLocationTaxonomy",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FacilityLocation",
                    "kind": "LinkedField",
                    "name": "facilityLocation",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FacilityLocationTaxonomy",
                        "kind": "LinkedField",
                        "name": "taxonomies",
                        "plural": true,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "seq",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Taxonomy",
                            "kind": "LinkedField",
                            "name": "taxonomy",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "code",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TaxonomyVersion",
                                "kind": "LinkedField",
                                "name": "applicableVersion",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "displayName",
                                    "storageKey": null
                                  },
                                  (v6/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "effectiveFrom",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "effectiveTo",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "12a199e68dd72488e01480e929bb442c",
    "id": null,
    "metadata": {},
    "name": "NewFacilityLocationTaxonomyModalMutation",
    "operationKind": "mutation",
    "text": "mutation NewFacilityLocationTaxonomyModalMutation(\n  $facilityLocationId: ID!\n  $taxonomyId: ID!\n  $seq: Int!\n  $effectiveFrom: DateOnly!\n  $effectiveTo: DateOnly!\n) {\n  facilityLocation {\n    createTaxonomy(input: {facilityLocationId: $facilityLocationId, taxonomyId: $taxonomyId, seq: $seq, effectiveFrom: $effectiveFrom, effectiveTo: $effectiveTo}) {\n      facilityLocationTaxonomy {\n        id\n        facilityLocation {\n          taxonomies {\n            ...FacilityLocationTaxonomies_Taxonomy\n            id\n          }\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment FacilityLocationTaxonomies_Taxonomy on FacilityLocationTaxonomy {\n  id\n  seq\n  taxonomy {\n    id\n    code\n    applicableVersion {\n      displayName\n      id\n    }\n  }\n  effectiveFrom\n  effectiveTo\n}\n"
  }
};
})();

node.hash = "3d30159907846e8d62499b0044a2e229";

export default node;
